import { createListViewContainer } from 'factories/ListView'
import selectors from 'selectors'
import actions from 'actions/jobReasonGroups'
import Component from 'components/JobReasonGroups'

export default createListViewContainer({ actions, selectors: selectors.jobReasonGroups })(Component)
